'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { getCmsHubRootUrl, handleRedirect } from 'pricing-pages-lib/utils/urls';
import { useSelector } from 'react-redux';
import { ENTERPRISE, PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { CMS, MARKETING } from 'self-service-api/constants/ProductLines';
import { SALES_HUB_STARTER, SERVICE_HUB_STARTER } from 'self-service-api/constants/ProductNames';
import VersionNumbers from 'self-service-api/constants/VersionNumbers';
import PurchaseMotionButton from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionButton';
import * as PurchaseMotionTypes from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { BUY_ADDITIONAL_CONTACTS, BUY_TOUCHLESS } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { hasProductVersionInProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { productForSkuIdSelector, productVersionSelector } from '../../selectors/ProductsSelectors';
import MarketingPurchaseMotionButtonWrapper from './MarketingPurchaseMotionButtonWrapper';
import { filteredPropsForPBM, getPurchaseMotionForLevel } from './PurchaseMotionButtonWrapper';
import SalesServiceSidegradeRedirectButton from './SalesServiceSidegradeRedirectButton';
export const useMarketingPMBOverride = propsToPass => {
  const {
    productConfigurations
  } = propsToPass;
  const purchaseMotion = getPurchaseMotionForLevel(propsToPass);
  const marketingProductFromConfig = useSelector(state => {
    return productConfigurations.map(({
      skuId
    }) => productForSkuIdSelector(state, {
      skuId
    })).find(({
      productLine
    }) => productLine === MARKETING);
  });

  if (purchaseMotion === BUY_TOUCHLESS && marketingProductFromConfig || purchaseMotion === BUY_ADDITIONAL_CONTACTS) {
    return /*#__PURE__*/_jsx(MarketingPurchaseMotionButtonWrapper, Object.assign({}, propsToPass));
  } // For Marketing Pro Trials we want to hide the redirect survey and send them to the trial guide


  if (marketingProductFromConfig && marketingProductFromConfig.productLevel === PROFESSIONAL && purchaseMotion === PurchaseMotionTypes.TRIAL) {
    return /*#__PURE__*/_jsx(PurchaseMotionButton, Object.assign({}, filteredPropsForPBM(propsToPass), {
      shouldHideSurvey: true
    }));
  }

  return null;
};

const useSalesServiceMarch2020Override = ({
  propsToPass,
  apiName
}) => {
  const purchaseMotion = getPurchaseMotionForLevel(propsToPass);
  const march2020SkuId = useSelector(state => productVersionSelector(state, {
    apiName,
    versionNumber: VersionNumbers[apiName].MARCH_2020
  }).skuId);
  const {
    productConfigurations
  } = propsToPass;
  const checkingOut2020Version = productConfigurations.some(({
    skuId: searchSkuId
  }) => searchSkuId === march2020SkuId);
  const ownsLegacyVersion = useSelector(state => hasProductVersionInProductInventorySelector(state, {
    apiName,
    versionNumber: VersionNumbers[apiName].LEGACY
  }));
  const productLine = useSelector(state => productForSkuIdSelector(state, {
    skuId: march2020SkuId
  }).productLine);

  if (purchaseMotion === PurchaseMotionTypes.BUY_TOUCHLESS && ownsLegacyVersion && checkingOut2020Version) {
    return /*#__PURE__*/_jsx(SalesServiceSidegradeRedirectButton, Object.assign({
      productLine: productLine,
      skuId: march2020SkuId
    }, propsToPass));
  }

  return null;
};

export const useSalesPMBOverride = propsToPass => useSalesServiceMarch2020Override({
  propsToPass,
  apiName: SALES_HUB_STARTER
});
export const useServicePMBOverride = propsToPass => useSalesServiceMarch2020Override({
  propsToPass,
  apiName: SERVICE_HUB_STARTER
});
export const useCmsPMBOverride = propsToPass => {
  const configsContainCMSEnterprise = useSelector(state => {
    const {
      productConfigurations
    } = propsToPass;
    return productConfigurations.some(({
      skuId
    }) => productForSkuIdSelector(state, {
      skuId
    }).productLine === CMS && productForSkuIdSelector(state, {
      skuId
    }).productLevel === ENTERPRISE);
  });
  const purchaseMotion = getPurchaseMotionForLevel(propsToPass);

  if (configsContainCMSEnterprise && (purchaseMotion === PurchaseMotionTypes.TRIAL || purchaseMotion === PurchaseMotionTypes.ACTIVATE)) {
    return /*#__PURE__*/_jsx(PurchaseMotionButton, Object.assign({}, filteredPropsForPBM(propsToPass), {
      onSuccess: () => handleRedirect(getCmsHubRootUrl())
    }));
  }

  return null;
};
export const usePMBOverride = propsToPass => {
  const marketingOverride = useMarketingPMBOverride(propsToPass);
  const salesOverride = useSalesPMBOverride(propsToPass);
  const serviceOverride = useServicePMBOverride(propsToPass);
  const cmsOverride = useCmsPMBOverride(propsToPass);
  return marketingOverride || salesOverride || serviceOverride || cmsOverride;
};